<div class="container">
  <div class="table" prlwResponsive [class.preloader-active]="preloaderActive">
    <div *ngIf="overflows?.top" class="top-fade"></div>
    <div
      *ngIf="overflows?.left && activeBasis === null"
      class="left-fade"
      prlwResponsive
    ></div>
    <div
      *ngIf="overflows?.right && activeBasis === null"
      class="right-fade"
      prlwResponsive
    ></div>

    <ng-container
      *ngIf="
        reqInstrumentsResult && !preloaderActive && data && !data.length;
        else content
      "
    >
      <div
        *ngIf="noSubProductsSelected"
        class="no-data-stub"
        data-cy="no-subproducts-selected-stub"
      >
        Пожалуйста, выберите хотя бы один подпродукт.
      </div>
      <div
        *ngIf="!noSubProductsSelected && hasUnselectedBases"
        class="no-data-stub"
        data-cy="no-bases-selected-stub"
      >
        Пожалуйста, добавьте хотя бы один базис.
      </div>
      <div
        *ngIf="noBasesAvailable"
        class="no-data-stub"
        data-cy="no-bases-available-stub"
      >
        Нет базисов для отображения.
      </div>
    </ng-container>
    <ng-template #content>
      <prlw-table-header-row
        [overflows]="overflows || undefined"
        (eventOpenManage)="openManageOverlay.emit()"
      ></prlw-table-header-row>

      <div
        #tableContentWrapper
        class="table-content-wrapper"
        [class.table-content-wrapper--all-selected]="!hasUnselectedBases"
        (scroll)="setHorizontalScroll($event)"
        prlwSyncScroll
      >
        <div
          *ngIf="rowHover.isVisible && rowHover.index !== activeBasis"
          class="row-hover"
          data-cy="table-row-hover"
          [ngStyle]="{ top: rowHover.offset }"
        >
          <prlw-instrument-remove-button
            (click)="removeBasis(rowHover.code)"
          ></prlw-instrument-remove-button>
        </div>

        <prlw-main-table-header
          *ngIf="(xsmall$ | async) === false"
        ></prlw-main-table-header>

        <div
          #tableContent
          class="table-content"
          *ngIf="reqInstrumentsResult && !preloaderActive; else contentLoader"
        >
          <div
            #scroll
            class="scroll"
            (scroll)="processVerticalScroll($event)"
            prlwResponsive
          >
            <prlw-table-row-ui
              data-cy="table-row"
              *ngFor="
                let instrument of data;
                let i = index;
                trackBy: trackByBasisCode
              "
              [class.expanded]="isExpanded && mode === 'pro'"
              [instrument]="instrument"
              [columns]="columns || []"
              [gridSize]="gridSize || '0'"
              [state]="getStateForRow(i)"
              [valueChanges]="getValueChanges(instrument.instrumentCode)"
              [tableContentClientWidthPx]="tableContentClientWidthPx"
              [tableHorizontalScrollPx]="tableHorizontalScrollPx"
              (mouseenter)="setRowHover($event, instrument.shipment.code, i)"
              (mouseleave)="setRowHover($event)"
              (toggleActive)="onToggleActive(i)"
              (removeBasis)="
                removeBasisAndUnsetActive(instrument.shipment.code)
              "
              prlwResponsive
            ></prlw-table-row-ui>
          </div>
        </div>
      </div>
    </ng-template>

    <div
      *ngIf="overflows?.bottom"
      class="bottom-fade"
      [class.bottom-fade--all-selected]="!hasUnselectedBases"
    ></div>

    <div
      *ngIf="mode === 'light'"
      [ngClass]="{
        'table-footer-2': hasUnselectedBases,
        'table-footer-1': !hasUnselectedBases,
        'mode-message': true,
      }"
    >
      <span class="mode-message__text"
        >Данные приходят с задержкой 15 минут!</span
      >
      <button class="mode-message__button" (click)="goToBuyLicense()">
        Ускорить!
      </button>
    </div>

    <ng-container *ngIf="(xsmall$ | async) === false">
      <div
        *ngIf="hasUnselectedBases && !preloaderActive"
        class="table-footer-1"
      >
        <button
          class="add-basis-button"
          data-cy="table-open-basis-overlay"
          (click)="openBasis()"
        >
          <prlw-icon
            name="round-plus"
            class="add-basis-button__icon"
          ></prlw-icon>
          <span>Добавить базис</span>
        </button>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="(xsmall$ | async) === false">
    <div *ngIf="pinInstrument$ | async as instrument" class="pinned-instrument">
      <prlw-table-row-ui
        data-cy="table-row-pinned"
        [instrument]="instrument"
        [columns]="columns || []"
        [gridSize]="gridSize || '0'"
        [state]="rowStateActive"
        [valueChanges]="getValueChanges(instrument.instrumentCode)"
        [tableContentClientWidthPx]="tableContentClientWidthPx"
        [tableHorizontalScrollPx]="tableHorizontalScrollPx"
        (mouseenter)="setRowHover($event, instrument.shipment.code, 0)"
        (mouseleave)="setRowHover($event)"
        (removeBasis)="removeBasisAndUnsetActive(instrument.shipment.code)"
        [unpinned]="false"
      ></prlw-table-row-ui>
    </div>
  </ng-container>
</div>

<ng-template #contentLoader>
  <div
    class="loader-plug-wrapper"
    *ngFor="let plug of loaderPlugsLength"
    prlwResponsive
  >
    <div class="loader-plug loader-plug--basis"></div>
    <div class="loader-plug"></div>
  </div>
</ng-template>
